import { loadScript } from '@automattic/load-script';

declare global {
	interface Window {
		_tkq: Array< Array< any > >; // eslint-disable-line
	}
}

// Loads the script async
loadScript( '//stats.wp.com/w.js?67' );

const TRACKS_SPECIAL_PROPS_NAMES = [ 'geo', 'message', 'request', 'geocity', 'ip' ];

export function pushEventToTracksQueue( args: Array< any > ) { // eslint-disable-line
	if ( typeof window !== 'undefined' ) {
		window._tkq = window._tkq || [];
		window._tkq.push( args );
	}
}

export function recordTracksEvent( eventName: string, eventProperties: any ) { // eslint-disable-line
	eventProperties = eventProperties || {};

	// Rules and restrictions for eventName
	if ( ! eventName.length ) {
		console.error( 'Unable to record event with no eventName.' );
		return;
	}

	// Remove properties that have an undefined value
	// This allows a caller to easily remove properties from the recorded set by setting them to undefined
	eventProperties = Object.fromEntries(
		Object.entries( eventProperties ).filter( ( [ , val ] ) => typeof val !== 'undefined' )
	);

	for ( const key in eventProperties ) {
		if ( eventProperties[ key ] !== null && typeof eventProperties[ key ] === 'object' ) {
			const errorMessage =
					`Tracks: Unable to record event "${ eventName }" because nested ` +
					`properties are not supported by Tracks. Check '${ key }' on`;

			console.error( errorMessage, eventProperties );
			return;
		}

		if ( ! /^[a-z_][a-z0-9_]*$/.test( key ) ) {
			console.error(
				'Tracks: Event `%s` will be rejected because property name `%s` does not match /^[a-z_][a-z0-9_]*$/. ' +
						'Please use a compliant property name.',
				eventName,
				key
			);
		}

		if ( TRACKS_SPECIAL_PROPS_NAMES.indexOf( key ) !== -1 ) {
			console.error(
				"Tracks: Event property `%s` will be overwritten because it uses one of Tracks' internal prop name: %s. " +
						'Please use another property name.',
				key,
				TRACKS_SPECIAL_PROPS_NAMES.join( ', ' )
			);
		}
	}

	pushEventToTracksQueue( [ 'recordEvent', eventName, eventProperties ] );
}
